import { ToggleButtonGroup as MuiToggleButtonGroup } from "@mui/material";
import type { AriaAttributes, ReactNode } from "react";

type ToggleButtonGroupValue = string | string[] | null;

export type ToggleButtonGroupProps = AriaAttributes & {
  value?: ToggleButtonGroupValue;
  onChange?: (
    event: React.MouseEvent<HTMLElement>,
    value: ToggleButtonGroupValue,
  ) => void;
  exclusive?: boolean;
  fullWidth?: boolean;
  orientation?: "horizontal" | "vertical";
  size?: "small" | "medium";
  color?:
    | "standard"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
  children?: ReactNode;
};

export function ToggleButtonGroup({
  value,
  onChange,
  exclusive = false,
  fullWidth = false,
  orientation = "horizontal",
  size = "medium",
  color = "standard",
  children,
  ...props
}: ToggleButtonGroupProps) {
  return (
    <MuiToggleButtonGroup
      value={value}
      onChange={onChange}
      exclusive={exclusive}
      fullWidth={fullWidth}
      orientation={orientation}
      size={size}
      color={color}
      {...props}
    >
      {children}
    </MuiToggleButtonGroup>
  );
}
